import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import { IconButton } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import VerifiedIcon from '@mui/icons-material/Verified';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';

const filterOptions = [
  { value: 'my_profile', label: 'Авторизувались' },
  { value: 'manage_job', label: 'Переглядали Мої вакансії' },
  { value: 'create_job', label: 'Створювали вакансію' },
  { value: 'cv_database', label: 'Переглядали Базу резюме' },
  { value: 'purchase', label: 'Переглядали Прайс' },
];

const formatDate = dateString => {
  if (!dateString) return null;

  const date = new Date(dateString);

  if (isNaN(date)) {
    return 'Invalid date';
  }

  const year = date.getFullYear();
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

const getInterestStatus = status => {
  if (status === 'high') {
    return (
      <span className='d-flex align-items-center'>
        <LocalFireDepartmentRoundedIcon sx={{ mr: '8px', color: 'red' }} />
        Високий
      </span>
    );
  } else if (status === 'medium') {
    return (
      <span className='d-flex align-items-center'>
        <WarningRoundedIcon sx={{ mr: '8px', color: 'orange' }} />
        Середній
      </span>
    );
  } else if (status === 'low') {
    return (
      <span className='d-flex align-items-center'>
        <AcUnitRoundedIcon sx={{ mr: '8px', color: 'blue' }} />
        Низький
      </span>
    );
  } else {
    return '';
  }
};

const APActivityList = () => {
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const { t } = useTranslation('global');
  const adminID = Cookies.get('adminID');

  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const [toDate, setToDate] = useState('');
  const [symbol, setSymbol] = useState('🔺');
  const [fromDate, setFromDate] = useState('');
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  // const [selectAll, setSelectAll] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  // const [checkedData, setCheckedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [positionFrom, setPositionFrom] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [sorting, setSorting] = useState({ last_date: 'desc' });

  const page = 1;
  const per_page = 20;

  const indexOfFirstItem = positionFrom;
  const indexOfLastItem = (positionFrom + per_page) >= totalCount ? totalCount : (positionFrom + per_page - 1);

  const handlePageChange = async page => {
    try {
      const positionNumber = page * per_page - per_page;

      setLoading(true);
      setCurrentPage(page);
      setPositionFrom(positionNumber);

      const response = await axios.get(
        BaseApi + '/admin/users/activity',
        {
          params: {
            page,
            per_page,
            ...sorting,
            filter: filter ? filter : null,
            to_date: toDate ? toDate : null,
            from_date: fromDate ? fromDate : null,
            search_query: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setTotalCount(response.data.total);
      setPositionFrom(response.data.from);
      setTotalPages(response.data.last_page);
      setListData(response.data.activityList);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  //   const handleOpen = plan => {
  //     setSelectedPayment(plan);
  //     setOpen(true);
  //   };

  const handleClose = () => {
    setSelectedPayment(null);
    setOpen(false);
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + '/admin/users/activity',
        {
          params: {
            page,
            per_page,
            ...sorting,
            filter: filter ? filter : null,
            to_date: toDate ? toDate : null,
            from_date: fromDate ? fromDate : null,
            search_query: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setTotalCount(response.data.total);
      setPositionFrom(response.data.from);
      setTotalPages(response.data.last_page);
      setListData(response.data.activityList);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      setLoading(false);

      console.error('Cannot get plans data at APmanageplans', error);
    }
  };

  const handleSearchClick = async e => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + '/admin/users/activity',
        {
          params: {
            page,
            per_page,
            ...sorting,
            filter: filter ? filter : null,
            to_date: toDate ? toDate : null,
            from_date: fromDate ? fromDate : null,
            search_query: searchQuery ? searchQuery : null,
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setTotalCount(response.data.total);
      setPositionFrom(response.data.from);
      setTotalPages(response.data.last_page);
      setListData(response.data.activityList);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Employer List', error);
    }
  };

  // const handleCheck = id => {
  //   if (id === 'selectAll') {
  //     setSelectAll(!selectAll);

  //     const updatedCheckedData = selectAll
  //       ? listData.map(item => item.id)
  //       : [];
  //     setCheckedData(updatedCheckedData);
  //   } else {
  //     if (checkedData.includes(id)) {
  //       setCheckedData(checkedData.filter(checkedId => checkedId !== id));
  //     } else {
  //       setCheckedData([...checkedData, id]);
  //     }
  //   }
  // };

  const handleColumnClick = async key => {
    const currentDirection = sorting[key] === 'asc' ? 'desc' : 'asc';

    setSymbol(currentDirection === 'desc' ? '🔺' : '🔻');
    setSorting({ [key]: currentDirection });
  };

  const handleSearchChange = e => {
    const newQuery = e.target.value.toLowerCase();

    setSearchQuery(newQuery);
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  useEffect(() => {
    getData();
  }, [sorting]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic APManageSubadmin'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container'></div>
            ) : (
              <>
                <div className='site-min-height'>
                  <div className='breadCumb1' role='presentation'>
                    <Breadcrumbs
                      aria-label='breadcrumb'
                      separator={<NavigateNextIcon fontSize='small' />}
                    >
                      <Link
                        color='inherit'
                        underline='hover'
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/admin/admins/dashboard')}
                      >
                        Dashboard
                      </Link>
                      <Link
                        color='inherit'
                        underline='hover'
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/admin/users')}
                      >
                        Employers
                      </Link>
                      <Typography color='text.primary'>Activity List</Typography>
                    </Breadcrumbs>
                  </div>
                  <div className='ManageSubAdminHeader'>
                    <h2 className=''>Activity List</h2>
                  </div>
                  <div className='manageSubadminPart1'>
                    <form onSubmit={handleSearchClick}>
                      <div className='manageSubadminPart1Sec1'>
                        <h4>
                          Search employer by typing Company ID, Company name or Email
                        </h4>
                        <div className='APJobsListSearch'>
                          <div className='APDashboardSearchBx '>
                            <input
                              type='text'
                              name='searchQuery'
                              value={searchQuery}
                              placeholder='Search..'
                              className='form-control'
                              onChange={handleSearchChange}
                            />
                          </div>
                          <input
                            type='date'
                            value={fromDate}
                            className='dateInput form-control'
                            onChange={e => setFromDate(e.target.value)}
                          />
                          <input
                            type='date'
                            value={toDate}
                            className='dateInput form-control'
                            onChange={e => setToDate(e.target.value)}
                          />
                          <select
                            name='filter'
                            value={filter}
                            className='filterSelect form-select'
                            onChange={e => setFilter(e.target.value)}
                          >
                            <option value=''>Оберіть фільтр</option>
                            {
                              filterOptions.map(i => (
                                <option key={i.value} value={i.value}>
                                  {i.label}
                                </option>
                              ))
                            }
                          </select>
                          <button
                            type='submit'
                            onClick={handleSearchClick}
                            className='btn navButton1 APMSbutton'
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </form>
                    <h4>
                      {t('pagination.NoofRecords')}
                      {' '}
                      {indexOfFirstItem} - {indexOfLastItem}
                      {' '}{t('pagination.of')}{' '}
                      {totalCount}
                    </h4>
                  </div>
                  {
                    listData != ''
                      ? (
                        <>
                          <div className='manageSubadminPart2'>
                            <table className='table'>
                              <thead>
                                <tr>
                                  {/* <td className='checkBoxCol checkBxHead'>
                                    <input
                                      type='checkbox'
                                      className='tableCheckBox'
                                      onClick={() => handleCheck('selectAll')}
                                    />
                                  </td> */}
                                  <th>
                                    Company ID
                                  </th>
                                  <th>
                                    Company Name
                                  </th>
                                  <th>
                                    Email
                                  </th>
                                  <th onClick={() => handleColumnClick('my_profile')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Вхід клієнта
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('last_date')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Активність клієнта
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('my_profile')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      Вхід адмін
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('my_profile')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      Дата адмін
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('manage_job')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Переглядали Мої вакансії
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('create_job')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Створювали вакансію
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('cv_database')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Переглядали Базу резюме
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('purchase')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Переглядали Прайс
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('interest_status')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      {symbol}
                                      {' '}
                                      Статус інтересу
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  listData?.map(i => (
                                    <tr key={i.id}>
                                      {/* <td className='checkBoxCol'>
                                        <input
                                          type='checkbox'
                                          className='tableCheckBox'
                                          onChange={() => handleCheck(i.id)}
                                          checked={checkedData.includes(i.id)}
                                        />
                                      </td> */}
                                      <td>{i.employer_id}</td>
                                      <td>
                                        {i.employer.company_name ? i.employer.company_name : 'Компанію видалено'}
                                        <span className='verifiedUsername'>
                                          {i.verify === 1 ? <VerifiedIcon sx={{ cursor: 'default' }} /> : ''}
                                        </span>
                                      </td>
                                      <td>{i.employer.email_address ? i.employer.email_address : 'Компанію видалено'}</td>
                                      <td>{i.my_profile}</td>
                                      <td>{formatDate(i.last_date)}</td>
                                      <td>{i.admin_auth}</td>
                                      <td>{formatDate(i.admin_auth_date)}</td>
                                      <td>{i.manage_job}</td>
                                      <td>{i.create_job}</td>
                                      <td>{i.cv_database}</td>
                                      <td>{i.purchase}</td>
                                      <td>{getInterestStatus(i.interest_status)}</td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                          <div className='manageSubadminpart3'>
                            <div className='mb-5 pagination'>
                              <Stack spacing={2}>
                                <Pagination
                                  color='primary'
                                  boundaryCount={2}
                                  count={totalPages}
                                  page={currentPage}
                                  onChange={(event, page) => handlePageChange(page)}
                                />
                              </Stack>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className='appliedJobListNoData'>No Records Found</div>
                      )
                  }
                  <div>
                    <Modal
                      open={open}
                      className='modalMain'
                      onClose={handleClose}
                      aria-labelledby='modal-modal-title'
                      aria-describedby='modal-modal-description'
                    >
                      <Box className='modal adminModal modal-content'>
                        <IconButton
                          onClick={handleClose}
                          className='close-button'
                          style={{
                            top: 10,
                            right: 10,
                            position: 'absolute',
                          }}
                        >
                          &times;
                        </IconButton>
                        <Typography
                          variant='h6'
                          component='h2'
                          id='modal-modal-title'
                        ></Typography>
                        <Typography
                          sx={{ mt: 3 }}
                          id='modal-modal-description'
                        >
                          {
                            selectedPayment && (
                              <div className='modals'>
                                <div className='modalHead'>
                                  <h1>
                                    {selectedPayment.first_name}
                                    {' '}
                                    {selectedPayment.last_name}
                                  </h1>
                                </div>
                                <div className='modalBody mt-4'>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Company Name:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.company_name}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Position:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.position}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      First Name:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.first_name}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Last Name:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.last_name}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Address:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.address}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Email Address:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.email_address}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Contact Number:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.contact}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Company Number:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.company_contact}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Website:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.url}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </Typography>
                      </Box>
                    </Modal>
                  </div>
                </div>
              </>
            )
        }
      </div>
    </>
  );
};

export default APActivityList;
